import { FunctionComponent } from "react"
import { Spinner } from "react-bootstrap"
import uuid from "react-uuid"
import "./LazyLoading.css"

interface Props {
    id?: string
}

const LazyLoading: FunctionComponent<Props> = (props) => {

    const { id } = props

    return (
        <div
            id={id ? id : uuid()}
            className="LazyLoading"
        >
            <Spinner
                id="f7da38f07ed54800b64961d67f33e3ab"
                animation="border"
            />
        </div>
    )
}

export default LazyLoading